import React from 'react'
import { HeaderSubtitleCentered } from 'newComponents'
import classNames from 'classnames'
import './styles.scss'

const TabsHeaderSubtitle = ({ header, subtitle, tabs, setCurrentTab, currentTab }) => (
  <>
    <HeaderSubtitleCentered header={header} subtitle={subtitle} />
    <div className="tabs is-centered is-large u-margintop-small">
      <ul>
        {tabs.map((tab) => {
          const { label } = tab
          return (
            <li key={label} className={classNames({ 'is-active': currentTab === label })}>
              <button
                onClick={() => {
                  setCurrentTab(label)
                }}
                type="button"
              >
                {label}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  </>
)

export default TabsHeaderSubtitle
